import contract from '@mailobj-browser/front/js/contracts/contract.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../styles.js'

import audio_and_camera from './controls/audio_and_camera.js'
import camera from './controls/camera.js'
// import audio_test from './controls/audio_test.js'
import cancel from './controls/cancel.js'
import chat from './controls/chat.js'
import delegate from './controls/delegate.js'
import done from './controls/done.js'
import fullScreen from './controls/fullscreen.js'
import fullScreenOff from './controls/fullscreenoff.js'
import mute from './controls/mute.js'
import muteall from './controls/muteall.js'
import opener from './controls/opener.js'
import pause from './controls/pause.js'
import shareScreen from './controls/sharescreen.js'
import shareScreenOff from './controls/sharescreenoff.js'
import stop from './controls/stop.js'
import switchCam from './controls/switchCam.js'
import unmute from './controls/unmute.js'
import X from './meet_x.js'
import { ctrlButton } from './ui.js'

export default contract({
  audio_and_camera: array([
    audio_and_camera,
    opener
  ]),
  opener: array([
    opener
  ]),
  // audio_test: array([
  //   audio_test
  // ]),
  camera: array([
    camera
  ]),
  cancel: array([
    cancel
  ]),
  done: array([
    done
  ]),
  pause: array([
    pause
  ]),
  switchCam: array([
    switchCam
  ]),
  mute: array([
    mute
  ]),
  unmute: array([
    unmute
  ]),
  muteall: array([
    muteall
  ]),
  fullScreen: array([
    fullScreen
  ]),
  fullScreenOff: array([
    fullScreenOff
  ]),
  chat: array([
    chat
  ]),
  shareScreen: array([
    shareScreen
  ]),
  shareScreenOff: array([
    shareScreenOff
  ]),
  delegate: array([
    delegate
  ]),
  stop: array([
    stop
  ])
})

export const show = (container) => {
  const controls = one(`.${elements.meet_connect} .${elements.meet_controls}`, container)

  if (controls) {
    const extendedFeatures = getComputedStyle(controls).getPropertyValue('--ea_chat_meet_controls_extended_features')

    if (extendedFeatures === 'true') {
      const shareScreen = ctrlButton('shareScreen', container)
      const fullScreen = ctrlButton('fullScreen', container)
      const newWindow = one(`.${elements.control_new_window}`, container)

      shareScreen?.classList.remove(utilities.modifiers.display.none)
      fullScreen?.classList.remove(utilities.modifiers.display.none)
      newWindow?.classList.remove(utilities.modifiers.display.none)
    }
  }

  X.ctrl()
}